import { render, staticRenderFns } from "./SupplierDetail.vue?vue&type=template&id=7aa33646&scoped=true"
import script from "./SupplierDetail.vue?vue&type=script&lang=ts"
export * from "./SupplierDetail.vue?vue&type=script&lang=ts"
import style0 from "./SupplierDetail.vue?vue&type=style&index=0&id=7aa33646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa33646",
  null
  
)

export default component.exports